import { LPSettlementEventTypeEnum, type LPSettlementEventTypeEnum as LPSettlementEventType } from '@talos/kyoko';

const LP_SETTLEMENT_EVENT_TYPE_LABELS: Record<LPSettlementEventType, string> = {
  [LPSettlementEventTypeEnum.Trade]: 'Trade',
  [LPSettlementEventTypeEnum.AssetTransaction]: 'Asset Transaction',
};

export function getLPSettlementEventTypeDisplayLabel(eventType: string | undefined): string {
  if (!eventType) {
    return '';
  }
  // Grid getLabel passes a string; Record lookup needs the enum key type.
  return LP_SETTLEMENT_EVENT_TYPE_LABELS[eventType as LPSettlementEventType] ?? eventType;
}
